import { render, staticRenderFns } from "./TagUserModal.vue?vue&type=template&id=fbbb7d60"
import script from "./TagUserModal.vue?vue&type=script&lang=js"
export * from "./TagUserModal.vue?vue&type=script&lang=js"
import style0 from "./TagUserModal.vue?vue&type=style&index=0&id=fbbb7d60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports